/**
 * Analytics - Search Events
 * 
 * @atomic - Search tracking
 * @modular - Search-specific events
 * 
 * Purpose: Track search queries and interactions
 * Exports: trackSearch, trackSearchInteraction
 */

import { trackEvent } from './core'

/**
 * Track search
 */
export const trackSearch = (searchType, query) => {
  trackEvent('Search', 'query', searchType, null, { query: query })
}

/**
 * Track search interactions
 */
export const trackSearchInteraction = (action, metadata = {}) => {
  trackEvent('Search', action, null, null, metadata)
}

/**
 * Track search result click
 */
export const trackSearchResultClick = (resultType, resultId, position) => {
  trackEvent('Search', 'result_click', resultType, position, {
    result_id: resultId
  })
}

/**
 * Track search autocomplete
 */
export const trackSearchAutocomplete = (query, resultCount, selectedIndex = null) => {
  trackEvent('Search', 'autocomplete', null, resultCount, {
    query: query,
    selected_index: selectedIndex
  })
}
